export const defaultCategories = [
  "الكل",
  "قهوة ساخنة",
  "قهوة باردة",
  "مشروبات ساخنة",
  "مشروبات باردة",
  "سموذي",
  "كوكتيل",
  "ميلك شيك",
  "مكسات",
  "وافل",
  "سناكات",
  "أراجيل",
  "إضافات",
];

export const categories = defaultCategories.map((name) => ({ name }));
